import { excuseApi } from '../commons/http';
import PurchaseOrder from '../models/purchaseOrder';

export const getPurchaseOrders = async (params) => {
  const res = await excuseApi({
    path: '/purchase-orders',
    method: 'GET',
    params,
  });
  return res.data;
};

export const getPurchaseOrder = async (id) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}`,
    method: 'GET',
  });
  const purchaseOrder = new PurchaseOrder();
  purchaseOrder.mapData(res.data.data);
  return purchaseOrder;
};

export const createPurchaseOrder = async (data) => {
  const res = await excuseApi({
    path: '/purchase-orders',
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const updatePurchaseOrder = async (id, data) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}`,
    method: 'PUT',
    body: data,
  });
  return res.data;
};

export const changePurchaseOrderStatus = async (id, status, notes = '') => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}`,
    method: 'PATCH',
    body: { status, notes },
  });
  return res.data;
};

export const getPurchaseOrderForReceiving = async (id) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/receiving`,
    method: 'GET',
  });
  return res.data;
};

export const submitPurchaseOrderReceiving = async (id, items) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/receive`,
    method: 'POST',
    body: { items },
  });
  return res.data;
};

export const markPurchaseOrderReceived = async (id) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/mark-received`,
    method: 'PATCH',
    body: {},
  });
  return res.data;
};

export const updatePurchaseOrderItemCosts = async (id, items) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/items/costs`,
    method: 'PATCH',
    body: { items },
  });
  return res.data;
};

// Returns API functions
export const getPurchaseOrderReturns = async (id) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/returns`,
    method: 'GET',
  });
  return res.data;
};

export const createPurchaseOrderReturn = async (id, data) => {
  const res = await excuseApi({
    path: `/purchase-orders/${id}/returns`,
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const getReturnReasons = async () => {
  const res = await excuseApi({
    path: '/purchase-orders/return-reasons',
    method: 'GET',
  });
  return res.data;
};